import React from 'react';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import CookiePrefsHelp from './CookiePrefsHelp';
const PrivacyPolicy = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.FooterPrivacy[key][currentLang];

  return (
    <section className="grid">
      <div className="contentfront">
        <div className="page-content privacy-page">
          <h1>🔐{t("title")}</h1>
          <p>{t("intro")}</p>

          <div className="highlight-box">
            <h2>{t("collectionTitle")}</h2>
            <ul className="styled-bullets">
              <li>{t("infoName")}</li>
              <li>{t("infoEmail")}</li>
              <li>{t("infoTransaction")}</li>
              <li>{t("infoUsage")}</li>
            </ul>

          <h2> {t("qcControllerTitle")}</h2>
<p dangerouslySetInnerHTML={{ __html: t("qcControllerText") }} />

<h2> {t("qcMinorsTitle")}</h2>
<p>{t("qcMinorsText")}</p>

<h2> {t("qcProfilingTitle")}</h2>
<p>{t("qcProfilingText")}</p>

<h2> {t("qcTransfersTitle")}</h2>
<p>{t("qcTransfersText")}</p>

<h2> {t("qcIncidentsTitle")}</h2>
<p>{t("qcIncidentsText")}</p>

<h2> {t("qcRightsTitle")}</h2>
<p>{t("qcRightsText")}</p>

<h2> {t("qcRetentionTitle")}</h2>
<p>{t("qcRetentionText")}</p>

<h2> {t("qcAutomatedTitle")}</h2>
<p>{t("qcAutomatedText")}</p>

<h2> {t("legalBasisTitle")}</h2>
<p>{t("legalBasisText")}</p>

<h2> {t("socialLoginTitle")}</h2>
<p>{t("socialLoginText")}</p>

<h2> {t("exerciseRightsTitle")}</h2>
<p>
  {t("exerciseRightsText")}{" "}
  <a href="/account/delete-data">{t("exerciseRightsLinkText")}</a>.
</p>

<h2> {t("cookiePrefsTitle")}</h2>
<p>
  {t("cookiePrefsText")}{" "}
  <CookiePrefsHelp t={t}/>
</p>

<h2> {t("ccpaTitle")}</h2>
<p>{t("ccpaText")}</p>

<p className="last-updated">{t("lastUpdated", { date: "2025-10-12" })}</p>

{/* 🧩 Third-Party Services */}
<h2> {t("thirdPartyTitle")}</h2>
<p>{t("thirdPartyText")}</p>

{/* 🔄 Policy Updates */}
<h2>🔄 {t("updateTitle")}</h2>
<p>{t("updateText")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
